// ** React Imports
import React, { useEffect } from "react";

// ** Third Party Imports
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

// ** Icons Imports
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

// ** Store Imports
import { deleteCustomerAction, getCustomers } from "../../store/reducers/customers/customersActions";
import * as userTypes from "../../store/reducers/auth/userTypes";

// ** Custom Components
import Datatable from "../../components/Datatable/Datatable";

// ** Hooks
import { useDate } from "../../hooks/useDate";

export default function Customers() {
    const { dateFormat } = useDate();
    const dispatch = useDispatch();
    const history = useHistory();
    const intl = useIntl();
    const customers = useSelector(state => state.customer_assing.customers);
    const message = useSelector(state => state.customer_assing.message);
    const userType = useSelector(state => (state.auth.user) ? state.auth.user.type : "invitado");
    const locale = useSelector(state => state.locale.locale);

    useEffect(() => {
        dispatch(getCustomers());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (message){
            switch (message.type){
                case "DELETE_CUSTOMER_SUCCESS":
                    dispatch({type:"TOGGLE_MODAL"});
                    toast.success(intl.formatMessage({id:"customer.success.delete"}));

                    dispatch(getCustomers());
                    break;
                default:
            }
            dispatch({type:"CLEAR_SUCCESS_MESSAGE"});
        }
    });

    const columns = [
        {
            name: intl.formatMessage({id: "general.name"}),
            selector: "name",
            sortable: true,
            grow: 2
        },
        ...(userType === userTypes.IDISC_ADMIN ? [
            {
                name: intl.formatMessage({id: "customer.last_login"}),
                selector: "last_login",
                sortable: true,
                grow: 1.5
            },
            {
                name: intl.formatMessage({id: "general.date"}),
                selector: row => row.last_login_date ? dateFormat(row.last_login_date, locale.name) : null,
                sortable: true,
                sortFunction: (a, b) => new Date(a.last_login_date) - new Date(b.last_login_date)
            }
        ] : []),
        {
            name: intl.formatMessage({id: "customer.last_project_approved"}),
            selector: "last_project_approved",
            sortable: true,
            grow: 1.5
        },
        {
            name: intl.formatMessage({id: "general.date"}),
            selector: row =>
                row.last_project_approved_date ? dateFormat(row.last_project_approved_date, locale.name) : null,
            sortable: true,
            sortFunction: (a, b) => new Date(a.last_project_approved_date) - new Date(b.last_project_approved_date)
        },
        ...(userType === userTypes.IDISC_ADMIN ? [
            {
                name: "",
                maxWidth: "100px",
                selector: row => (
                    <button
                        className="button is-small is-danger"
                        title={intl.formatMessage({id: "general.delete"})}
                        onClick={()=> deleteCustomer(row)}
                    >
                            <span className="icon">
                                <FontAwesomeIcon className="" icon={faTrash}/>
                            </span>
                    </button>
                )
            }
        ] : [])
    ];

    const editCustomer = (id, name) => history.push({pathname: `/customers/${id}/edit`, exact: true, state: {customer_name: name}});

    const deleteCustomer = customer => {
        dispatch({
            type: 'TOGGLE_MODAL',
            payload: {
                title: intl.formatMessage({id: "message_title.delete_customer"}),
                message: intl.formatMessage({id: "message.delete"}, {item: customer.name}),
                acceptButton: intl.formatMessage({id: "general.delete"}),
                cancelButton: intl.formatMessage({id: "general.cancel"}),
                acceptButtonClass: "is-danger",
                acceptButtonMethod: () => deleteCustomerHandler(customer.id),
            }
        })
    }

    const deleteCustomerHandler = id => {
        dispatch(deleteCustomerAction(id));
    }

    const createCustomer = () => history.push({pathname: "/customers/create", exact: true});

    return (
        <>
            <div className="box">
                <h4 className="title is-4 has-text-primary">
                    <FormattedMessage id="menu.clients"/>
                </h4>
                <div className="level">
                    <div className="level-left"></div>
                    <div className="level-right">
                        {userType === userTypes.IDISC_ADMIN && (
                            <div className="level-item">
                                <button className="button is-outlined is-primary" onClick={createCustomer}>
                                    <FormattedMessage id="customer.add_customer"/>
                                </button>
                            </div>
                        )}
                    </div>
                </div>
                <div className="table-container">
                    <Datatable columns={columns} data={customers} onRowClicked={row => editCustomer(row.id, row.name)}/>
                </div>
            </div>
        </>
    )
}
